module.exports = __webpack_public_path__ + "img/portugal.ada259b5.svg";